import { StepDefinitionStrategy } from './step-definition.strategy';
import { Injectable } from '@angular/core';
import { RouteIds, Step } from '../../types';
import { GoogleAnalyticsEventEnum } from '../../google-analytics';

@Injectable({
  providedIn: 'root',
})
export class ConfirmationStepDefinitionService implements StepDefinitionStrategy {
  private stepDefinition: Step = {
    id: RouteIds.confirmation,
    googleAnalyticsEvent: GoogleAnalyticsEventEnum.Confirmation,
  };

  getStepDefinition() {
    return {
      ...this.stepDefinition,
    };
  }
}
